import React, { useEffect, useState } from 'react'
import InfoIcon from '@mui/icons-material/Info'
import { Stack, Tooltip, Typography } from '@mui/material'
import { Box } from '@mui/system'
import NormalText from 'common/Typography/NormalText'
import TextColorFontBody from 'common/Typography/TextColorFontBody'
import circlesOrbitColorPalette from 'common/ui/circlesColorTheme'
import {
  ICustomerSubHistoryDetails,
  ISimServiceStatusDetails
} from 'types/api/faber/subscription.type'

export interface SubStatusCardProps {
  getSubHistory: ICustomerSubHistoryDetails[]
  simServiceStatus: ISimServiceStatusDetails
  onSuccessfulFormSubmission: () => void
}
export default function SubStatusCard({
  getSubHistory,
  simServiceStatus,
  onSuccessfulFormSubmission
}: SubStatusCardProps) {
  const [textColor, setTextColor] = useState('')
  const [finalSimStatus, setFinalSimStatus] = useState('')

  useEffect(() => {
    switch (getSubHistory[0].status) {
      case 'ACTIVE':
        {
          if (simServiceStatus.status === 'ACTIVE') {
            setFinalSimStatus('ACTIVE')
            setTextColor(circlesOrbitColorPalette.success.main)
          } else if (simServiceStatus.status === 'SUSPENDED') {
            setFinalSimStatus('ERROR')
            setTextColor(circlesOrbitColorPalette.error.main)
          }
        }
        break
      case 'CANCELLED':
        setFinalSimStatus('CANCELLED')
        setTextColor(circlesOrbitColorPalette.neutrals[500])
        break
      case 'EXPIRING':
        setFinalSimStatus('EXPIRING')
        setTextColor('#ed6c02')
        break
      case 'SUSPENDED':
        setFinalSimStatus('SUSPENDED')
        setTextColor(circlesOrbitColorPalette.error.main)
        break
    }
  }, [getSubHistory, simServiceStatus, onSuccessfulFormSubmission])

  return (
    <>
      <Box
        sx={{
          backgroundColor: '#FFFFFF',
          borderRadius: '34px',
          p: '40px',
          maxWidth: '215px'
        }}
      >
        <NormalText
          isBold
          textAlign={'left'}
          sx={{
            fontSize: '24px',
            fontWeight: '700px',
            m: 0
          }}
          text={'Subscription'}
        />
        <TextColorFontBody
          sx={{
            fontSize: '14px',
            lineHeight: 1,
            color: '#7B8794',
            textAlign: 'left',
            mt: '10px'
          }}
        >
          The current status of the customer&apos;s most recent subscription.
        </TextColorFontBody>

        <Stack
          flexDirection={'row'}
          sx={{ mt: '37px', justifyContent: 'space-between' }}
        >
          <Stack>
            <Typography
              sx={{
                fontWeight: '400',
                color: '#7B8794',
                justifyContent: 'space-between'
              }}
              textAlign='left'
            >
              Status
            </Typography>

            <Stack flexDirection={'row'} spacing={1}>
              <Typography
                sx={{
                  fontWeight: '600',
                  fontSize: '33px',
                  pt: '15px',
                  color: textColor
                }}
              >
                {finalSimStatus}
              </Typography>
              {finalSimStatus === 'ERROR' ? (
                <Tooltip
                  PopperProps={{
                    sx: { maxWidth: '165px', textAlign: 'center' }
                  }}
                  title={
                    'There is an error with the SIM service status from Telna. Please contact L3 for help'
                  }
                >
                  <InfoIcon fontSize='small' color='error' />
                </Tooltip>
              ) : (
                ''
              )}
            </Stack>
          </Stack>
        </Stack>
      </Box>
    </>
  )
}
